// LineItem/LineItemTable.jsx
import React from 'react';
import {
  Box,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
} from '@chakra-ui/react';

import { formatAmount } from 'utils/util';

import LineItemRow from './LineItemRow';

const LineItemTable = ({
  textColor,
  headerBg,
  columnHeaders,
  lineItems,
  itemData,
  uqcData,
  businessTypes,
  company,
  companySetting,
  lastDaybook,
  selectcompany,
  type,
  wareshow,
  lineitemview,
  lineDetailview,
  warehouseList,
  purchase,
  pendingReceive,
  totals,
  errors,
  refs,
  prerefs,
  billTermData,
  addLineItem,
  removeLineItem,
  handleOnChange,
  handleStockModalOnClick,
  handleModalOpen,
  setCurrentLineItemIdx,
  activeRow,
  setActiveRow,
}) => {
  return (
    <Box overflowX="auto">
      <TableContainer maxH="100%" border="1px" borderColor="gray.200" borderRadius={5}>
        <Table variant="simple" size="sm">
          {/* ---------- HEADER ---------- */}
          <Thead bg={headerBg}>
            <Tr>
              <Th color={textColor}>Index</Th>
              <Th color={textColor}>Action</Th>

              {(selectcompany?.setting?.warehouseWishStock === true &&
                lineitemview === true) ||
                (wareshow && type === 'purchase' && lineDetailview === true) ||
                (wareshow && type === 'recive' && lineDetailview === true) ? (
                <Th color={textColor} minW="210px">
                  Ware House
                </Th>
              ) : null}

              {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                lastDaybook &&
                (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork) ? (
                <Th color={textColor} minW="250px">
                  Purchase Documents
                </Th>
              ) : null}

              {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                lastDaybook &&
                lastDaybook?.isMillReceive &&
                lastDaybook?.issuedaybookid !== null ? (
                <Th color={textColor} minW="250px">
                  Issued Documents
                </Th>
              ) : null}

              <Th color={textColor} minW="250px">
                Item
              </Th>

              {lastDaybook?.isAskTypeOfSupply ? (
                <Th color={textColor} minW="210px">
                  Type of Supply
                </Th>
              ) : null}

              {companySetting?.maxUOM > 1 ? (
                <Th color={textColor} minW="250px">
                  Unit
                </Th>
              ) : null}

              {columnHeaders.slice(0, companySetting?.maxUOM).map((header, index) => (
                <Th key={index} color={textColor} minW="100px">
                  {header}
                </Th>
              ))}

              {lastDaybook?.isAllowGstRate && lastDaybook?.applyGst && companySetting?.applyGST ? (
                <Th color={textColor} minW="120px">
                  GST Rate
                </Th>
              ) : null}

              <Th color={textColor} minW="120px">
                Rate
              </Th>

              {lastDaybook?.requireDiscountLineItem > 0 ? (
                <Th color={textColor} minW="120px">
                  Amount
                </Th>
              ) : null}

              {lastDaybook?.requireDiscountLineItem > 0 &&
                new Array(lastDaybook?.requireDiscountLineItem)
                  .fill()
                  .map((_, index) => (
                    <React.Fragment key={index}>
                      <Th color={textColor} minW="120px">
                        Disc{index + 1} (%)
                      </Th>
                      <Th color={textColor} minW="120px">
                        Disc AMT {index + 1}
                      </Th>
                    </React.Fragment>
                  ))}

              <Th color={textColor} minW="100px">
                Net Amt
              </Th>

              {company?.setting?.applyGST && lastDaybook?.applyGst ? (
                <>
                  <Th color={textColor} minW="100px">
                    GST %
                  </Th>
                  <Th color={textColor} minW="100px">
                    GST Taxable
                  </Th>
                  <Th color={textColor} minW="100px">
                    GST Amt
                  </Th>
                  <Th color={textColor} minW="100px">
                    Amt + GST
                  </Th>
                </>
              ) : null}

              {lastDaybook?.isAllowNotes ? (
                <Th color={textColor} minW="150px">
                  Notes
                </Th>
              ) : null}

              {lastDaybook?.isAllowRemark ? (
                <Th color={textColor} minW="150px">
                  Remark
                </Th>
              ) : null}
            </Tr>
          </Thead>

          {/* ---------- BODY ---------- */}
          <Tbody>
            {lineItems?.map((lineItem, rowIndex) => (
              <LineItemRow
                key={rowIndex}
                rowIndex={rowIndex}
                lineItem={lineItem}
                lineItems={lineItems}
                columnHeaders={columnHeaders}
                itemData={itemData}
                uqcData={uqcData}
                businessTypes={businessTypes}
                company={company}
                companySetting={companySetting}
                lastDaybook={lastDaybook}
                selectcompany={selectcompany}
                type={type}
                wareshow={wareshow}
                lineitemview={lineitemview}
                lineDetailview={lineDetailview}
                warehouseList={warehouseList}
                purchase={purchase}
                pendingReceive={pendingReceive}
                errors={errors}
                refs={refs}
                prerefs={prerefs}
                billTermData={billTermData}
                addLineItem={addLineItem}
                removeLineItem={removeLineItem}
                handleOnChange={handleOnChange}
                handleStockModalOnClick={handleStockModalOnClick}
                handleModalOpen={handleModalOpen}
                setCurrentLineItemIdx={setCurrentLineItemIdx}
                textColor={textColor}
                activeRow={activeRow}
                setActiveRow={setActiveRow}
              />
            ))}
          </Tbody>

          {/* ---------- FOOTER ---------- */}
          <Tfoot>
            <Tr>
              <Th color={textColor}></Th>
              <Th color={textColor}>Action</Th>
              <Th color={textColor} colSpan={lastDaybook?.isAskTypeOfSupply ? 2 : 1}>
                Total
              </Th>

              {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                lastDaybook &&
                (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork) ? (
                <Th colSpan={1}></Th>
              ) : null}

              {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                lastDaybook &&
                lastDaybook?.isMillReceive &&
                lastDaybook?.issuedaybookid !== null ? (
                <Th colSpan={1}></Th>
              ) : null}

              {(selectcompany?.setting?.warehouseWishStock === true &&
                lineitemview === true) ||
                (wareshow && type === 'purchase' && lineDetailview === true) ||
                (wareshow && type === 'recive' && lineDetailview === true) ? (
                <Th></Th>
              ) : null}

              {companySetting?.maxUOM > 1 ? <Th></Th> : null}

              {companySetting?.maxUOM > 0 && companySetting?.maxUOM <= 3 ? (
                <Th color={textColor}>{totals?.qty1}</Th>
              ) : null}

              {companySetting?.maxUOM > 1 && companySetting?.maxUOM <= 3 ? (
                <Th color={textColor}>{totals?.qty2}</Th>
              ) : null}

              {companySetting?.maxUOM > 2 && companySetting?.maxUOM <= 3 ? (
                <Th color={textColor}>{totals?.qty3}</Th>
              ) : null}

              {lastDaybook?.isAllowGstRate && lastDaybook?.applyGst && companySetting?.applyGST ? <Th></Th> : null}

              <Th></Th>

              {lastDaybook?.requireDiscountLineItem > 0 ? (
                <Th color={textColor}>{totals?.basicAmount?.toFixed(2)}</Th>
              ) : null}

              {lastDaybook?.requireDiscountLineItem > 0 &&
                new Array(lastDaybook?.requireDiscountLineItem).fill().map((_, index) => (
                  <React.Fragment key={index}>
                    <Th></Th>
                    <Th color={textColor}>{totals[`discount${index + 1}`]}</Th>
                  </React.Fragment>
                ))}

              <Th color={textColor}>{formatAmount(totals?.netAmount)}</Th>

              {company?.setting?.applyGST && lastDaybook?.applyGst ? (
                <>
                  <Th></Th>
                  <Th color={textColor}>{formatAmount(totals?.taxableAmount)}</Th>
                  <Th color={textColor}>{formatAmount(totals?.netGstAmount)}</Th>
                  <Th></Th>
                </>
              ) : null}

              {lastDaybook?.isAllowNotes ? <Th></Th> : null}
              {lastDaybook?.isAllowRemark ? <Th></Th> : null}
            </Tr>
          </Tfoot>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LineItemTable;
